const oneMileInKilometer = 1.609344;
export default mile => mile * (oneMileInKilometer / 1);
